import colors from "../../../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const ForgotPasswordFormStyle = makeStyles((theme) => ({
	normalSeperator: {
		[theme.breakpoints.down("sm")]: {
			display: "none",
		},
	},
	smallSeperator: {
		display: "none",
		[theme.breakpoints.down("sm")]: {
			display: "block",
		},
	},
	paper: {
		paddingTop: theme.spacing(14),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: "100%",
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
		color: colors.white,
		fontWeight: "bold",
		"&:hover": {
			backgroundColor: colors.darkCrimsonRed,
		},
	},
	loaderContainer: {
		paddingTop: "10px",
	},
	loader: {
		height: "30px",
	},
	normalSeperator: {
		[theme.breakpoints.down("sm")]: {
			display: "none",
		},
	},
	smallSeperator: {
		display: "none",
		[theme.breakpoints.down("sm")]: {
			display: "block",
		},
	},
}));

export default ForgotPasswordFormStyle;
